import { Api_Paths } from "@/lib/api/paths";

let Access_Token: string | null = null;
let Refresh_In_Flight: Promise<string | null> | null = null;

export function Auth_Access_Set(Token: string): void {
  Access_Token = Token;
}

export function Auth_Access_Get(): string | null {
  return Access_Token;
}

export function Auth_Access_Clear(): void {
  Access_Token = null;
}

export async function Auth_Session_Restore(): Promise<string | null> {
  if (Access_Token) {
    return Access_Token;
  }

  if (Refresh_In_Flight) {
    return Refresh_In_Flight;
  }

  Refresh_In_Flight = (async () => {
    const Response = await fetch(Api_Paths.V1.Auth.Refresh, {
      method: "POST",
      credentials: "include",
    });

    if (!Response.ok) {
      Auth_Access_Clear();
      return null;
    }

    const Body = (await Response.json()) as { accessToken?: string };
    if (!Body.accessToken) {
      Auth_Access_Clear();
      return null;
    }

    Auth_Access_Set(Body.accessToken);
    return Body.accessToken;
  })().finally(() => {
    Refresh_In_Flight = null;
  });

  return Refresh_In_Flight;
}

export async function Auth_Fetch(Url: string, Init?: RequestInit): Promise<Response> {
  const Request_Headers = new Headers(Init?.headers);
  const Token = Auth_Access_Get();

  if (Token) {
    Request_Headers.set("Authorization", `Bearer ${Token}`);
  }

  let Response = await fetch(Url, { ...Init, headers: Request_Headers, credentials: "include" });

  if (Response.status === 401) {
    Auth_Access_Clear();
    const Refreshed = await Auth_Session_Restore();
    if (Refreshed) {
      Request_Headers.set("Authorization", `Bearer ${Refreshed}`);
      Response = await fetch(Url, { ...Init, headers: Request_Headers, credentials: "include" });
    }
  }

  return Response;
}
